import { render, staticRenderFns } from "./InventoryCategorySelector.vue?vue&type=template&id=89a4a8a6&scoped=true&"
import script from "./InventoryCategorySelector.vue?vue&type=script&lang=js&"
export * from "./InventoryCategorySelector.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCategorySelector.vue?vue&type=style&index=0&id=89a4a8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a4a8a6",
  null
  
)

export default component.exports